const s=".cds-breadcrumbs{display:flex}";export{s as default};
